module.exports = __webpack_public_path__ + "img/peanuts.72592cc3.jpg";